import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { MediaFtpExportSettings } from "../../Model/recurringJobs/ftp/mediaFtpExportSettings";
import { ModelService } from "../model.service";

@Injectable()
export class MediaFtpExportSettingsService {
  constructor(public modelService: ModelService, private http: HttpClient) {

  }

  public getById(id: number): Observable<MediaFtpExportSettings> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString())
    }
    return (this.http.get("api/MediaFtpExportSettings/Get", options)) as any;
  }

  public getAll(): Observable<MediaFtpExportSettings[]> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", this.modelService.loginService.currentCustomer.id)
    }
    return (this.http.get("api/MediaFtpExportSettings/GetAll", options)) as any;
  }

  public update(setting: MediaFtpExportSettings): Observable<MediaFtpExportSettings> {
    var result = this.http.post<MediaFtpExportSettings>("api/MediaFtpExportSettings/Update", setting);
    return (result);
  }

  public create(setting: MediaFtpExportSettings): Observable<MediaFtpExportSettings> {
    setting.customerId = this.modelService.loginService.currentCustomer.id;
    var result = this.http.post<MediaFtpExportSettings>("api/MediaFtpExportSettings/Create", setting);
    return (result);
  }

  public delete(id: number): Observable<MediaFtpExportSettings> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString())
    }
    return (this.http.delete<MediaFtpExportSettings>("api/MediaFtpExportSettings/Delete", options)) as any;
  }

  public run(id: number): Observable<MediaFtpExportSettings> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("id", id.toString())
    }
    return (this.http.get<object>("api/MediaFtpExportSettings/Run", options)) as any;
  }
}
